import { render, staticRenderFns } from "./CustomerHistoryNotesForm.vue?vue&type=template&id=7e0c49bb&"
import script from "./CustomerHistoryNotesForm.vue?vue&type=script&lang=js&"
export * from "./CustomerHistoryNotesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports